module.exports = __webpack_public_path__ + "static/media/tmnt.3c27941a.mp3";